const searchRoot = document.querySelector('main.page-content--search');
const searchPageForm =
    searchRoot && searchRoot.querySelector('body.search .main-searchform');
const postsContainer =
    searchRoot &&
    searchRoot.querySelector('.search-page-posts .js-search-posts-container');
const topBar =
    searchRoot && searchRoot.querySelector('.search-page-top__results');
const input =
    searchPageForm && searchPageForm.querySelector('input[type="search"');
const formBtn =
    searchPageForm && searchPageForm.querySelector('button[type="submit"]');
const loadMoreBtn =
    searchRoot && searchRoot.querySelector('body.search .js-search-load');

export default () => {
    if (!searchRoot) {
        return;
    }

    searchPageForm.addEventListener('submit', (e) => getPosts(e, true));

    searchPageForm.addEventListener('click', (e) => {
        if (e.target.matches('.clear')) {
            e.preventDefault();
            formBtn.classList.remove('clear');
            searchPageForm.classList.remove('clear');
            input.value = '';
            input.readOnly = false;
            input.focus();
        }
    });

    loadMoreBtn.addEventListener('click', (e) => getPosts(e, false, true));

    input.addEventListener('click', () => {
        input.readOnly = false;
        input.focus();
    });

    input.addEventListener('focus', (e) => {
        formBtn.classList.remove('clear');
        searchPageForm.classList.remove('clear');
    });

    input.addEventListener('blur', (e) => {
        input.readOnly = true;
        if (e.relatedTarget === formBtn) {
            return;
        }
        input.value = input.getAttribute('value');
        if (input.value) {
            formBtn.classList.add('clear');
            searchPageForm.classList.add('clear');
        }
    });
};

const getPosts = (e, deletePosts = false, loadMore = false) => {
    e.preventDefault();
    searchRoot.classList.add('ajax-loading');

    if (loadMore) {
        searchRoot.setAttribute(
            'data-page',
            parseInt(searchRoot.getAttribute('data-page')) + 1
        );
    }

    fetch(WP.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body: new URLSearchParams({
            action: 'search_load_more',
            s: input.value,
            paged: searchRoot.getAttribute('data-page'),
            ppp: searchRoot.getAttribute('data-ppp'),
        }),
    })
        .then((response) => response.json())
        .then((response) => {
            // when new keyword is provided
            if (deletePosts) {
                // remove posts from container
                while (postsContainer.firstChild) {
                    postsContainer.removeChild(postsContainer.lastChild);
                }

                // update top bar
                while (topBar.firstChild) {
                    topBar.removeChild(topBar.lastChild);
                }
                topBar.insertAdjacentHTML('beforeend', response.top_bar);

                // update root attributes
                searchRoot.setAttribute('data-page', 1);
                searchRoot.setAttribute('data-keyword', input.value);
                searchRoot.setAttribute('data-max-page', response.max_page);

                // update input value
                input.setAttribute('value', input.value);

                // update window url
                window.history.replaceState(null, null, `?s=${input.value}`);

                // update form state
                input.blur();
            }

            // add new posts to container
            postsContainer.insertAdjacentHTML('beforeend', response.posts);

            // update load more button visibility
            const btnStyle =
                searchRoot.getAttribute('data-page') <
                    searchRoot.getAttribute('data-max-page')
                    ? 'inline-flex'
                    : 'none';
            loadMoreBtn.style.display = btnStyle;

            searchRoot.classList.remove('ajax-loading');
        })
        .catch((err) => {
            searchRoot.classList.add('ajax-loading');
            input.blur();
            console.log(err);
        });
};
